module.exports = __webpack_public_path__ + "img/artyferia.e5214f4a.svg";